export const ADMIN_ROUTE = '/admin'
export const LOGIN_ROUTE = '/login'
export const INVENTORY_ROUTE = '/inventory'
export const CHARACTER_ROUTE = '/character'
export const RATING_ROUTE = '/rating'
export const AUTH_ROUTE = '/auth'
export const NOT_AUTH_ROUTE = '/notauth'
export const PREPARE_ROUTE = '/prepare'
export const TRADE_ROUTE = '/trade'
export const MAP_ROUTE = '/map'
export const DONATION_ROUTE = '/donation'
export const REACT_APP_API_URL = window.location.origin
export const SERVER_APP_API_URL = `${window.location.origin}/api`
export const TERMS_ROUTE = '/terms-and-privacy';
export const GUILD_ROUTE = '/guild';
//export const SERVER_APP_API_URL = "http://localhost:7000/api"//https://rxu72ucoa6kj.share.zrok.io/api"//"http://localhost:7001"//https://il50ac22xeo3.share.zrok.io"//"https://zpe9mdfuf45w.share.zrok.io"
//https://7436re8xig7n.share.zrok.io"
//"https://rgslcj1xubmx.share.zrok.io"//"https://afb2ltd94zwl.share.zrok.io" //"http://localhost:7000"
